<template>
    <div v-if="slicedList && slicedList.length">
        <div class="static-gs">
            <b>{{title}}</b>
        </div>
        <div class="static-gs" :class="{'gs-sm-2':twoCols}">
            <a class="link" v-for="home in slicedList" :href="appUrl + home[urlKey]">
                {{home.displayName}} {{subText}}
            </a>
        </div>
        <div class="static-gs" v-if="itemsList.length > maxItems">
            <span class="see-less">
                <a class="see-less link f5" v-show="showAll" @click="toggle(0)">See less <i class=" f7 icon-angle-up"></i></a>
            </span>
            <span class="see-more">
                <a class="see-all link f5" v-show="!showAll" @click="toggle(1)">See more <i class="f7 icon-angle-down"></i></a>
            </span>
        </div>
    </div>
</template>

<script src="./guide-hub-sidecontent.js"></script>

<style lang="scss">
@use "./guide-hub-sidecontent.scss" as *;
</style>